export * from './name-form-settings.component';
export * from './name-form-settings.module';
